import { fetchHil, fetchHil2 } from "../utils";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    items: [],
    targetId: null
  },
  getters: {},
  mutations: {
    setItems(state, { items, targetId }) {
      state.items = items;
      state.targetId = targetId;
    }
  },
  actions: {
    async deleteTimelineItem({ state, dispatch }, { item }) {
      await fetchHil2(
        "delete",
        `/timeline/${item._id}`
      );
      await dispatch("fetchTimelineItems");
    },
    async fetchTimelineItems({ state, commit }, { targetId = state.targetId }) {
      const items = await fetchHil2("get", `/timeline/for/${targetId}`);
      items.sort((a, b) => {
        return moment(a.date).isBefore(b.date) ? 1 : -1;
      });

      commit("setItems", {
        items
      });
    }
  }
};
